import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import {ReactComponent as StepperActive} from "../../assets/images/stepper/stepper-no-active.svg";

const NonActiveStep = () => {
  return (
      <SvgIcon>
        <StepperActive/>
      </SvgIcon>
  )
};

export default NonActiveStep;
